import { INTERNAL_CONSTANTS } from '@constants/internalConstants'
import { graphQLClient } from './graphqlClient'

export const networkClient = async ({
  mode = INTERNAL_CONSTANTS.NETWORK_CLIENT.GRAPHQL,
  request = {},
}) => {
  if (mode === INTERNAL_CONSTANTS.NETWORK_CLIENT.GRAPHQL) {
    return graphQLClient(request)
  }
}
